import { createContext } from 'react';

export interface YearContextType {
  selectedYear: number;
  setSelectedYear: (y: number) => void;
  availableYears: number[];
  loading: boolean;
}

export const YearContext = createContext<YearContextType>({
  selectedYear: new Date().getFullYear(),
  setSelectedYear: () => {},
  availableYears: [],
  loading: true,
});
